import { render } from "./Figure0.vue?vue&type=template&id=54101a32&bindings={}"
import script from "./Figure0.vue?vue&type=script&lang=ts"
export * from "./Figure0.vue?vue&type=script&lang=ts"
script.render = render

export default script